<template>
  <div v-if="!item.hidden">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link
        v-if="onlyOneChild.meta"
        :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <svg-icon
            :icon-class="
              onlyOneChild.meta.icon || (item.meta && item.meta.icon)
            "
          />
          <template #title
            ><span class="menu-title-wrap"
              ><span
                class="menu-title"
                :title="hasTitle(onlyOneChild.meta.title)"
                >{{ onlyOneChild.meta.title }}</span
              ><span
                v-if="todoCount(resolvePath(onlyOneChild.path)) > 0"
                class="menu-todo-badge"
                >{{ formatTodoCount(todoCount(resolvePath(onlyOneChild.path))) }}</span
              ></span
            ></template
          >
        </el-menu-item>
      </app-link>
    </template>

    <el-sub-menu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      teleported
    >
      <template v-if="item.meta" #title>
        <svg-icon :icon-class="item.meta && item.meta.icon" />
        <span class="menu-title" :title="hasTitle(item.meta.title)">{{
          item.meta.title
        }}</span>
      </template>

      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { isExternal } from "@/utils/validate";
import AppLink from "./Link";
import { getNormalPath } from "@/utils/ruoyi";
import useBusinessTodoStore from "@/store/modules/businessTodo";

const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: "",
  },
});

const onlyOneChild = ref({});
const businessTodoStore = useBusinessTodoStore();

function todoCount(path) {
  return businessTodoStore.countForPath(path);
}

function formatTodoCount(count) {
  return count > 99 ? "99+" : count;
}

function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false;
    }
    onlyOneChild.value = item;
    return true;
  });

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return true;
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: "", noShowingChildren: true };
    return true;
  }

  return false;
}

function resolvePath(routePath, routeQuery) {
  if (isExternal(routePath)) {
    return routePath;
  }
  if (isExternal(props.basePath)) {
    return props.basePath;
  }
  if (routeQuery) {
    let query = JSON.parse(routeQuery);
    return {
      path: getNormalPath(props.basePath + "/" + routePath),
      query: query,
    };
  }
  return getNormalPath(props.basePath + "/" + routePath);
}

function hasTitle(title) {
  if (title.length > 5) {
    return title;
  } else {
    return "";
  }
}
</script>
<style scoped>
.menu-title-wrap {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: calc(100% - 8px);
  gap: 8px;
}

.menu-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-todo-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  color: #fff;
  background: #f04438;
  box-shadow: 0 0 0 2px #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
}

:deep(.el-menu-item.is-active) .menu-todo-badge {
  color: #ff830e;
  background: #fff;
  box-shadow: none;
}

/* #app
  .sidebar-container
  .nest-menu
  .is-active
  .el-menu-item
  > .el-sub-menu__title:hover,
#app .sidebar-container .el-sub-menu .is-active:hover {
  background: #ff830e !important;
} */
#app .sidebar-container .nest-menu .el-sub-menu > .el-sub-menu__title:hover,
#app .sidebar-container .nest-menu .el-sub-menu .is-active:hover {
  background: #ff830e !important;
}
#app .sidebar-container .nest-menu .el-sub-menu > .el-sub-menu__title:hover,
#app .sidebar-container .el-sub-menu .el-menu-item.is-active:hover {
  background: #ff830e !important;
}
</style>
